import { Component } from '@angular/core';
import { NavbarComponent } from "../../partials/navbar/navbar.component";
import { FooterComponent } from "../../partials/footer/footer.component";
import { LanguageService } from '../../services/language.service';
import { Title } from '@angular/platform-browser';
import { PartnersCarrouselComponent } from "../../components/partners-carrousel/partners-carrousel.component";

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [NavbarComponent, FooterComponent, PartnersCarrouselComponent],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css'
})
export class AboutUsComponent {
  texts: any;
  constructor(private langService:LanguageService, private title:Title){
    this.texts = this.langService.getWebisteTexts().about_us;
  
    if (this.langService.getLanguage() == 'es') {
      this.title.setTitle('PRINX - Quiénes somos') 
    }else{
      this.title.setTitle('PRINX - About Us')
    }
  }

  navigateToId(id: string): void {
    if (typeof document === 'undefined') {
      return;
    }
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
  }
}
